import { FolderKanban, Image, LayoutDashboard, LogOut, Newspaper } from 'lucide-react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { clearToken } from '../api/client';
import { Button } from './components/button';
import { cn } from '../lib/utils';
import './idare.css';

const navItems = [
  { to: '/idare/projects', label: 'Projeler', icon: FolderKanban },
  { to: '/idare/blog-posts', label: 'Blog Yazıları', icon: Newspaper },
  { to: '/idare/photos', label: 'Fotoğraflar', icon: Image },
];

function IdareLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearToken();
    navigate('/idare/login');
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      'flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium text-[hsl(var(--muted-foreground))] transition-colors hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--foreground))]',
      isActive && 'bg-[hsl(var(--secondary))] text-[hsl(var(--foreground))]'
    );

  return (
    <div id="idare-root" className="idare-root flex min-h-screen">
      <aside className="flex w-60 shrink-0 flex-col border-r border-[hsl(var(--border))] bg-[hsl(var(--card))] p-4">
        <div className="mb-6 flex items-center gap-2 px-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]">
            <LayoutDashboard className="h-4 w-4" />
          </span>
          <span className="text-base font-semibold">İdare</span>
        </div>
        <nav className="flex flex-1 flex-col gap-1">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={linkClass}>
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <Button
          variant="ghost"
          className="w-full justify-start gap-2.5 px-3 text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]"
          onClick={handleLogout}
        >
          <LogOut className="h-4 w-4" /> Çıkış
        </Button>
      </aside>
      <main className="flex-1 overflow-auto p-8">
        <Outlet />
      </main>
    </div>
  );
}

export default IdareLayout;
